import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import fileDownload from 'js-file-download';

export default class DataDownload extends React.Component {
  handleImageDownload = () => {
    const { id, dataUrl } = this.props;
    axios.get(dataUrl).then((response) => {
      fileDownload(JSON.stringify(response.data), `data-${id}.txt`);
    });
  }

  render() {
    return (
      <button className="btn btn-primary" onClick={this.handleImageDownload}>Download Data</button>
    );
  }
}

DataDownload.propTypes = {
  id: PropTypes.string.isRequired,
  dataUrl: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DataDownload.jsx